import { useQuery } from '@tanstack/react-query';
import { leaveService } from '@/services/leave/leaveService';
import { leaveQueryKeys } from './queryKeys';

export const useCompanyEmployees = () => {
  return useQuery({
    queryKey: leaveQueryKeys.employees(),
    queryFn: () => leaveService.getCompanyEmployees(),
    staleTime: 10 * 60 * 1000, // 10 minutes (employees don't change often)
  });
};
